import { Router } from '@angular/router';
import { Component, HostBinding } from '@angular/core';
import { Location } from '@angular/common';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  @HostBinding('attr.data-version') readonly appVersion = environment.appVersion;

  constructor(private router: Router,
    private location: Location) {
  }


  goBack() {
    this.location.back();
  }
}
